import { pushEvent } from '../helpers/utils'

interface SortableEvent {
  item: HTMLElement
  newIndex: number
  oldIndex: number
  from: HTMLElement
  to: HTMLElement
}

export const FacadeSortable = {
  async mounted() {
    try {
      // Load SortableJS (npm package, handled by build system)
      const Sortable = await import('sortablejs')

      const TARGET = this.el.getAttribute('phx-target')
      const EVENT_ON_SORT = this.el.dataset.eventOnSort
      const EVENT_ON_MOVE = this.el.dataset.eventOnMove
      const GROUP_NAME = this.el.dataset.sortableGroup

      // Build config - add group option if specified for cross-list dragging
      const config: Record<string, unknown> = {
        draggable: '[data-component=".sortable_item"]',
        handle: '[data-part="handle"]',
        animation: 150,
        onSort: (event: SortableEvent) => {
          // Only fire if item stayed in same list
          if (event.from === event.to && EVENT_ON_SORT) {
            pushEvent(
              this,
              EVENT_ON_SORT,
              {
                id: this.el.id,
                group_id: this.el.dataset.groupId,
                data: {
                  id: event.item.id,
                  index: event.newIndex
                }
              },
              TARGET,
              'Sortable update failed'
            )
          }
        }
      }

      // Enable cross-list dragging if group is specified
      if (GROUP_NAME) {
        config.group = GROUP_NAME

        // Handle items moved from another list
        config.onAdd = (event: SortableEvent) => {
          if (EVENT_ON_MOVE) {
            const fromGroupId = event.from.dataset.groupId
            const toGroupId = event.to.dataset.groupId

            pushEvent(
              this,
              EVENT_ON_MOVE,
              {
                id: this.el.id,
                data: {
                  id: event.item.id,
                  index: event.newIndex,
                  from_group_id: fromGroupId,
                  to_group_id: toGroupId
                }
              },
              TARGET,
              'Sortable move failed'
            )
          }
        }
      }

      // Initialize sortable with improved error handling
      this.sortable = Sortable.default.create(this.el, config)
    } catch (_error) {
      this.el.style.cursor = 'not-allowed'
      this.el.title = 'Drag and drop functionality not available'
    }
  },

  destroyed() {
    // Clean up sortable instance
    if (this.sortable) {
      this.sortable.destroy()
      this.sortable = null
    }
  }
}
